import {WADILY_LIVE_STATUS, CarrierStateFields} from './dto/carrier-state-dto';
import MainUtils from '../../utils/main';

export const ACCEPTED_ONWARD_STATUSES: ReadonlyArray<string> = [
  WADILY_LIVE_STATUS.Accepted,
  WADILY_LIVE_STATUS.OnTheWayToPickup,
  WADILY_LIVE_STATUS.Delivering,
  WADILY_LIVE_STATUS.Delivered,
  WADILY_LIVE_STATUS.Rejected,
];

export const shouldShowExternalShipmentNumber = (
  state?: Pick<CarrierStateFields, 'LiveShipmentStatus' | 'ExternalShipmentOrderNumber'> | null,
): boolean => {
  if (MainUtils.isEmptyValue(state?.ExternalShipmentOrderNumber)) {
    return false;
  }
  if (!state?.LiveShipmentStatus) {
    return false;
  }
  return ACCEPTED_ONWARD_STATUSES.includes(state.LiveShipmentStatus);
};

export const isShipmentNumberEmphasized = (
  state?: Pick<CarrierStateFields, 'LiveShipmentStatus'> | null,
): boolean => {
  return state?.LiveShipmentStatus === WADILY_LIVE_STATUS.OnTheWayToPickup;
};
